import styled, { css } from 'styled-components'

const StyledStatusLabel = styled.div`
  width: 87px;
  min-height: 20px;
  text-align: center;
  border-radius: 10px;
  text-transform: uppercase;
  font-size: ${props => props.theme.fontSizes.statusLabel};
  font-family: ${props => props.theme.fonts.robotoBold};
  line-height: 13px;
  letter-spacing: 0.42px;
  padding: 4px;

  ${props =>
    props.default &&
    css`
      background: ${props => props.theme.colors.iron};
      color: ${props => props.theme.colors.oxfordBlue};
    `}

  ${props =>
    props.active &&
    css`
      background: ${props => props.theme.colors.curiousBlue};
      color: ${props => props.theme.colors.white};
    `}

  ${props =>
    props.success &&
    css`
      background: ${props => props.theme.colors.seeGreen};
      color: ${props => props.theme.colors.white};
    `}

  ${props =>
    props.warning &&
    css`
      background: ${props => props.theme.colors.red};
      color: ${props => props.theme.colors.white};
    `}

  ${props =>
    props.pending &&
    css`
      background: ${props => props.theme.colors.darkOrange};
      color: ${props => props.theme.colors.white};
    `}
    ${props =>
      props.preAccess &&
      css`
        background: ${props => props.theme.colors.amaranth2};
        color: ${props => props.theme.colors.white};
      `}
    ${props =>
      props.waitingForReview &&
      css`
        background: ${props => props.theme.colors.rebeccaPurple};
        color: ${props => props.theme.colors.white};
      `}
  ${props =>
    // TODO I think these statuses are only used for mission statuses, so
    // pending, warning, etc, doesn't make much sense, could be refactored
    props.checkedIn &&
    css`
      background: ${props => props.theme.colors.forestGreen};
      color: ${props => props.theme.colors.white};
    `} 
  ${props =>
    props.isSpied &&
    css`
      border: 2px solid #ee4360;
    `}

    
    ${props =>
      props.underReview &&
      css`
        background: ${props => props.theme.colors.darkOrange};
        color: ${props => props.theme.colors.white};
      `}
 

    ${props =>
      props.draft &&
      css`
        background: ${props => props.theme.colors.yellow};
        color: ${props => props.theme.colors.white};
      `}
    

`

export default StyledStatusLabel



// WEBPACK FOOTER //
// ./src/Components/StatusLabel/style.js